import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GenerateCaptions } from "../../redux/slice/genrateai/GenerateCaptionSlice.js";
import './GenerateAi.css';
// import { Link } from "react-router-dom";

const GenerateCaption = () => {
  const [prompt, setPrompt] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false); 
  const dispatch = useDispatch();
  const { captions: captionData, loading, error } = useSelector((state) => state.GenerateCaption || {});

  // Check if the user is logged in on component mount
  useEffect(() => {
    const userToken = true; 
    if (userToken) {
      setIsLoggedIn(true); 
    } else {
      setIsLoggedIn(false); 
    }
  }, []);

  const handleGenerateCaptions = () => {
    if (prompt.trim()) {
      dispatch(GenerateCaptions(prompt));
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleGenerateCaptions();
    }
  };

  const handleCopyToClipboard = () => {
    if (captionData && captionData.captions) {
      const captionString = captionData.captions;
      navigator.clipboard.writeText(captionString)
        .then(() => {
          setIsCopied(true);
          setTimeout(() => setIsCopied(false), 5000);
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    }
  };

  if (!isLoggedIn) {
    return (
      <div className="text-center ">
        <div className="alert alert-warning background-dark p-5" role="alert">
          <h4 className="alert-heading landing-text-white">You need to log in!</h4>
          <p className="landing-text-white"> Please log in to view your Generate Caption Dashboard.</p>
          <div className="d-flex justify-content-center">
            <button className="btn btn-primary m-2" onClick={() => window.location.href = "/dashboard"}>
              Log in
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container my-5">
      <h3 className="text-center mb-5">Generate Captions</h3>
      <div className="generate-box row flex-nowrap">
        <div className="col-md-6 col-lg-5 d-flex align-items-center bg-gradient-info py-4 rounded-lg shadow-lg border w-50 justify-content-center">
          <div className="text-center mt-2">
            <h5 className="text-primary mb-4 mt-1">Generate AI Captions</h5>
            <input
              type="text"
              className="form-control mb-4 mt-5 p-3 fs-5 rounded-3"
              placeholder="Enter Caption"
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              onKeyPress={handleKeyPress}
            />
            <button
              className="btn btn-warning w-100 mt-2 mb-5 p-3 rounded-3"
              onClick={handleGenerateCaptions}
            >
              Generate Captions
            </button>
          </div>
        </div>

        <div className="col-md-5 ms-sm-3 ms-0 col-lg-5 bg-gradient-info py-4 rounded-lg shadow-lg border w-50">
          <div className="mt-1">
            {loading ? (
              <div className="spinner"></div>
            ) : error ? (
              <div>Error: {error}</div>
            ) : (
              captionData && captionData.captions ? (
                <div>
                  {captionData.captions.split('\n').map((caption, index) => (
                    <div
                      key={index}
                      className="badge bg-light text-dark p-3 rounded-pill shadow-sm my-3"
                      style={{
                        fontSize: "1rem",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {caption}
                    </div>
                  ))}

                  <div className="copy-button text-end">
                    <button
                      onClick={handleCopyToClipboard}
                      className={`btn rounded-3 justify-content-right ${isCopied ? 'btn-success' : 'btn-primary'}`}
                    >
                      {isCopied ? (
                        <i className="bi bi-check-circle-fill"></i>
                      ) : (
                        <i className="bi bi-clipboard-check"></i>
                      )}
                    </button>
                  </div>
                </div>
              ) : (
                <div>
                  <h5 className="text-center text-warning mb-4">Generated Captions</h5>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenerateCaption;
